import { FormValidators, VALIDATION_MESSAGES } from '../../../hooks/useForm';
import { LocalePost } from '../../../types/post';
import { isBlankHtml, validateKebabCase } from '../../../utils/validationUtils';

export const TITLE_MAX_CHAR = 60;
export const DESCRIPTION_MAX_CHAR = 270;
export const URL_MAX_CHAR = 50;

const { MAX_LENGTH, EMPTY_IMAGE, NOT_TITLE, NOT_DESCRIPTION, NOT_CONTENT, NOT_ALT, NOT_URL } = VALIDATION_MESSAGES;

export const POST_EDITOR_VALIDATORS: FormValidators<LocalePost> = {
  title: (post) => {
    const length = post.title?.length ?? 0;
    if (!length) return NOT_TITLE;
    if (length > TITLE_MAX_CHAR) return MAX_LENGTH(TITLE_MAX_CHAR);
  },
  description: (post) => {
    const length = post.description?.length ?? 0;
    if (!length) return NOT_DESCRIPTION;
    if (length > DESCRIPTION_MAX_CHAR) return MAX_LENGTH(DESCRIPTION_MAX_CHAR);
  },
  content: (post) => {
    if (isBlankHtml(post.content)) return NOT_CONTENT;
  },
  image: {
    alt: (image) => {
      if (!image.alt?.length) return NOT_ALT;
    },
    dashboardUrl: (image) => {
      if (!image.dashboardUrl?.length) return EMPTY_IMAGE;
      // TODO mejorar validacion chequeando que sea una imagen? A lo mejor el fileupload de prime ya lo hace?
    },
  },
  meta: {
    url: (meta) => {
      const value = meta.url;
      const length = value?.length ?? 0;
      if (!length) return NOT_URL;
      if (value && !validateKebabCase(value)) return 'La URL solo puede tener minúsculas sin tilde, números y guiones';
      if (length > URL_MAX_CHAR) return MAX_LENGTH(URL_MAX_CHAR);
    },
    title: (meta) => {
      if (!meta.title?.length) return NOT_TITLE;
    },
    description: (meta) => {
      if (!meta.description?.length) return NOT_DESCRIPTION;
    },
  },
};
